import { httpClient } from "@/services";

export default {
	state: {
		system_settings: {
			setting: [],
			maps: [],
			trailer_type: [],
			report_contacts: [],
			statistics_data: [],
		}
	},
	getters: {
		getSystemSettings(state) {
			return state.system_settings;
		},
		getDataSettings(state) {
			return state.system_settings.statistics_data;
		}
	},
	mutations: {
		SET_SETTINGS(state, payload) {
			state.system_settings = payload;
		},
		SET_MNGR(state, payload) {
			state.system_settings.statistics_data[1] = { selectedMgr: payload };
		},
		SET_SLS(state, payload) {
			state.system_settings.statistics_data[0] = { selectedSls: payload };
		},
		SET_HRS(state, payload) {
			state.system_settings.statistics_data[2] = { afterHrs: payload };
		},
		SET_SFT(state, payload) {
			state.system_settings.statistics_data[3] = { selectedSft: payload };
		},
	},
	actions: {
		mngr({ commit }, payload) {
			commit("SET_MNGR", payload);
		},
		sls({ commit }, payload) {
			commit("SET_SLS", payload);
		},
		hrs({ commit }, payload) {
			commit("SET_HRS", payload);
		},
		sft({ commit }, payload) {
			commit("SET_SFT", payload);
		},
		async onFetchSystemSettings({ commit }) {
			try {
				const { data } = await httpClient.get('/settings/system');
				if (data) {
					commit('SET_SETTINGS', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onFetchSaveSettings({ commit }, payload) {
			try {
				const { data } = await httpClient.post('/settings/system', payload);
				if (data.status) {
					delete data.status;
					commit('SET_SETTINGS', data);
					return true;
				}
				return false;
			} catch (e) {
				console.error(e);
			}
		}
	}
};
